package ru.villawonka.app.presentation.screens.setup.compose

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.navigator.currentOrThrow
import ru.villawonka.app.presentation.model.CountryUIModel
import ru.villawonka.app.presentation.model.CurrencyUIModel
import ru.villawonka.app.presentation.model.LanguageUIModel
import ru.villawonka.app.presentation.screens.setup.compose.layout.SetupRootLayout
import ru.villawonka.app.presentation.screens.setup.viewmodel.SetupUIEvent
import ru.villawonka.app.presentation.screens.setup.viewmodel.SetupUIState
import ru.villawonka.app.presentation.screens.setup.viewmodel.SetupViewModel

class SetupScreen : Screen {

    @Composable
    override fun Content() {
        val viewModel = koinScreenModel<SetupViewModel>()
        val state by viewModel.uiState.collectAsStateWithLifecycle(initialValue = SetupUIState.Loading)

        registerEventListener(viewModel, LocalNavigator.currentOrThrow)

        SetupRootLayout(
            state = state,
            callbacks = remember {
                SetupCallbacks(
                    onContinueButtonClick = viewModel::onContinueButtonClick,
                    onCountrySelected = viewModel::onCountrySelected,
                    onCurrencySelected = viewModel::onCurrencySelected,
                    onLanguageSelected = viewModel::onLanguageSelected,
                    onRetryButtonClick = viewModel::onRetryButtonClick
                )
            }
        )
    }

    @Composable
    private fun registerEventListener(viewModel: SetupViewModel, navigator: Navigator) {
        LaunchedEffect(Unit) {
            viewModel.events.collect { event ->
                when (event) {
                    is SetupUIEvent.Close -> navigator.pop()
                }
            }
        }
    }
}

data class SetupCallbacks(
    val onLanguageSelected: (LanguageUIModel) -> Unit,
    val onCountrySelected: (CountryUIModel) -> Unit,
    val onCurrencySelected: (CurrencyUIModel) -> Unit,
    val onContinueButtonClick: () -> Unit,
    val onRetryButtonClick: () -> Unit,
)